module.exports = __webpack_public_path__ + "static/media/CaptureDB1.900b435b.PNG";